module.exports = __webpack_public_path__ + "static/corgijpg-f03fb65b4f585bfe2dde13257a10a4b9.jpg";